function getTrackingCookies() {
  const cookies = document.cookie.split(';').reduce((acc, cookie) => {
    const [name, value] = cookie.trim().split('=');
    acc[name] = value;
    return acc;
  }, {});

  return {
    fbp: cookies._fbp || '',
    fbc: cookies._fbc || '',
    gclid: cookies._gcl_au || ''
  };
}
function syncTrackingCookies() {
  const { fbp, fbc, gclid } = getTrackingCookies();

  const attributes = {};
  if (fbp) attributes._fbp = fbp;
  if (fbc) attributes._fbc = fbc;
  if (gclid) attributes._gclid = gclid;

  if (Object.keys(attributes).length === 0) return;

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes })
  }).catch(err => console.error('Failed to sync tracking cookies', err));
}
document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('form[action^="/cart/add"]');
  if (!form) return;

  form.addEventListener('submit', function () {
    if (typeof syncTrackingCookies === 'function') {
      syncTrackingCookies();
    }
  });
});
